export const TOP_ANCHOR = 'SCROLL_TO_TOP'
export const BOTTOM_ANCHOR = 'SCROLL_TO_BOTTOM'
export const TOP_AND_BOTTOM_ANCHORS = [TOP_ANCHOR, BOTTOM_ANCHOR]
